<template>
  <el-dialog
    title="分享"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="500px"
  >
    <div class="eqWrap">
      <div class="eqImg" id="qrcode" ref="qrCodeUrl"></div>
      <div class="link">文章链接：{{ link }}</div>
      <div>
        <el-button type="text" @click="preserve">保存二维码</el-button>
        <el-button
          type="text"
          v-clipboard:copy="link"
          v-clipboard:error="onError"
          v-clipboard:success="onCopy"
          >复制链接</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  props: {
    id: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  watch: {
    id() {
      this.link =
        window.location.href.split('#')[0] +
        `#/information/article/articleInfo?articleId=${this.id}`
    },
  },
  data() {
    return {
      dialogVisible: false,
      link:
        window.location.href.split('#')[0] +
        `#/information/article/articleInfo?articleId=${this.id}`,
    }
  },
  methods: {
    isOpen() {
      this.dialogVisible = true
      this.$nextTick(() => {
        if (document.getElementById('qrcode')) {
          document.getElementById('qrcode').innerHTML = ''
          this.creatQrCode()
        }
      })
    },
    creatQrCode() {
      new QRCode(this.$refs.qrCodeUrl, {
        text: this.link,
        width: 150,
        height: 150,
        colorDark: '#333333', //二维码颜色
        colorLight: '#ffffff', //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      })
    },
    preserve() {
      let saveUrl = document.getElementById('qrcode').lastChild.src
      let aLink = document.createElement('a')
      let evt = document.createEvent('HTMLEvents')
      evt.initEvent('click', true, true)
      aLink.download = this.title + '.jpg'
      aLink.href = saveUrl
      aLink.click()
      if (aLink.href) {
        this.$message.success('保存成功')
      }
    },
    // 复制成功
    onCopy() {
      this.$message({
        message: '复制成功！',
        type: 'success',
      })
    },
    // 复制失败
    onError() {
      this.$message({
        message: '复制失败！',
        type: 'error',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.eqImg {
  width: 150px;
  height: 150px;
  margin: 0 auto;
  margin-bottom: 30px;
}
.eqWrap {
  text-align: center;
  button {
    margin: 0 60px;
  }
}
.link {
  margin-bottom: 20px;
}
</style>
